import * as api from '../../api/encargado-recupero-client';
import { 
    GET_CONFIG_FORM,
    GET_CRITERIOS_FECHA,
    GET_INSTANCIA_JUDICIAL,
    GET_ESTADOS_CASO,
    GET_TAREAS,
    GET_COMPANIAS,
    GET_TAREAS_USUARIO,
    GET_CASOS_BANDEJA,
    GET_RANGO_FECHAS,
    GET_XLS_CASOS_BANDEJA,
    CLEAR_CASOS_BANDEJA,
    GET_FILTROS,
    GET_SIT_PENDIENTE,
    GET_XLS_CASOS_BANDEJA_INTER_CIAS
} from '../types';


export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});

export const obtenerTareasAction = (query) => ({
    type: GET_TAREAS,
    payload: api.getTareas(query)
});

export const obtenerEstadosCasoAction = (query) => ({
    type: GET_ESTADOS_CASO,
    payload: api.getEstadoByGestion(query)
});

//RG-536 sólo la bandeja entre CIAs: sus estados salen de configuración (299003) y ya no de
//`estados-implicado` con el concepto 213, que incluía estados de casos cerrados.
export const obtenerEstadosFiltroAction = (query) => ({
    type: GET_ESTADOS_CASO,
    payload: api.getOpcionesFiltro(query)
});

export const obtenerCompanias = () => ({
    type: GET_COMPANIAS,
    payload: api.getCompanias()
});

export const obtenerInstanciaJudicial = (query) => ({
    type: GET_INSTANCIA_JUDICIAL,
    payload: api.getIntanciaJudicial(query)
});

export const obtenerCriteriosFechaAction = (query) => ({
    type: GET_CRITERIOS_FECHA,
    payload: api.getConceptos(query)
});

//RG-536 el Criterio Fecha de la bandeja entre CIAs sale de cfg_filtro_informes (299003 / 288002) y
//ya no del concepto 29. Escribe en la misma clave del store que la carga anterior.
export const obtenerCriteriosFechaFiltroAction = (query) => ({
    type: GET_CRITERIOS_FECHA,
    payload: api.getOpcionesFiltro(query)
});

export const obtenerTareasUsuarioAction = (query) => ({
    type: GET_TAREAS_USUARIO,
    payload: api.getTareasUsuario(query)
});

export const obtenerCasosBandeja = (query) => ({
    type: GET_CASOS_BANDEJA,
    payload: api.getCasosBandeja(query)
});

export const obtenerRangoFechas = (query) => ({
    type: GET_RANGO_FECHAS,
    payload: api.getRangoFechas(query)
});

export const obtenerXlsCasosBandeja = (query) => ({
    type: GET_XLS_CASOS_BANDEJA,
    payload: api.getXlsCasosBandeja(query)
});

export const limpiarCasosBandeja = () => ({
    type: CLEAR_CASOS_BANDEJA,
    payload: { casos: [], query: null }
});
export const obtenerFiltros = (filtros) => ({
    type: GET_FILTROS,
    payload: filtros
});
export const obtenerSituacionPendiente = (query) => ({
    type: GET_SIT_PENDIENTE,
    payload: api.getConceptos(query)
});
export const obtenerXlsCasosBandejaInterCias = (query) => ({
    type: GET_XLS_CASOS_BANDEJA_INTER_CIAS,
    payload: api.getXlsCasosBandejaInterCias(query)
});